import { useQuery } from '@tanstack/react-query';
import { multiProductFilterService } from '#client/services/multiProductFilter/multiProductFilterServices';

export function useCategoriesQuery(query) {
    return useQuery({
        queryKey: ['categories'],
        queryFn: async () => {
            const response = await multiProductFilterService.getCategories({ query });
            return response?.data || [];
        },
        enabled: !!query || query === '', // allow empty string for initial load
        staleTime: 5 * 60 * 1000, // optional: cache for 5 minutes
    });
}
